import React, { Component, useEffect } from 'react';
import Header from './Header';

export const Guideline = () => {

    const handlecloseWindow = (e) => {
        console.log("window close not happening")
        window.close();

    }
    return (
        <html xmlns="http://www.w3.org/1999/xhtml" >
            <head id="Head1"><meta http-equiv="expires" content="-1" /><meta http-equiv="pragma" content="no-cache" /><meta http-equiv="cache-control" content="no-cache" /><meta name="robots" content="noindex,nofollow" /><meta name="keywords" /><title>

            </title>
            </head>
<Header/>
            <body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0" bgcolor="#FFFFFF" text="#000000">
                {/* <!-- -- -- -- -- logo -- -- -- -- --> */}
                <br /><br />
                <div id="wrapper" class="default_bg">
                    <div id="content">
                        <a name="content"></a>
                        <div class="pod">
                            <div class="pod-top">
                                <hr />
                            </div>

                            <div class="pod-btm" style={{marginTop:'-10px'}}>
                                <div id="Page_1" class="curv-bl">
                                    {/* <!-- Start Page 1 --> */}
                                    <h1 class="app-title">Guidelines</h1>
                                    <div class="intro" style={{marginTop:'0px',paddingLeft: '4px'}}>
                                        <h1>Surname - field</h1>
                                        <p class="copy">Enter details with letters only.</p>
                                        <h1>Postal Code - field</h1>
                                        <p class="copy">Enter a valid UK Postal code with a space between first and last group of characters/numbers.</p>
                                        <h1>Date of Birth (YYYY-MM-DD) - field</h1>
                                        <p class="copy">Enter date in the format year-month-date.</p>
                                    </div> <br />
                                    <div class="spacer"></div>

                                    <div class="buttons">

                                        <div align="right" className="btnbg">
                                            <div className="t">
                                                <div className="r">
                                                    <div className="b">
                                                        <div className="l">
                                                            <div className="btntl">
                                                                <div className="btntr">
                                                                    <div className="btnbr">
                                                                        <div className="btnbl">
                                                                            <input
                                                                                type="button"
                                                                                name="direction"
                                                                                id="S_CANCEL"
                                                                                defaultValue=" Close "
                                                                                className="button-right no-arrow"
                                                                                title="Cancel the application - Warning: this will lose any data you have keyed in."
                                                                                onClick={e => handlecloseWindow(e)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
            <div className="footer" style={{display:'none'}}>
            </div>
        </html>
    )
}

export default Guideline;